
import { RequestPaging } from "@/utils/util";
import { Component, Vue } from "vue-property-decorator";
import LsDialog from "@/components/ls-dialog.vue";
import LsPagination from "@/components/ls-pagination.vue";
import PopoverInput from "@/components/popover-input.vue";
import LsForm from "@/components/ls-form.vue";
import {
  apiModelModelTagLists,
  apiModelModelTagAdd,
  apiModelModelTagEdit,
  apiModelModelTagDelete,
  apiModelModelTagCategoryLists,
} from "@/api/model.ts";
@Component({
  components: {
    LsDialog,
    LsPagination,
    PopoverInput,
    LsForm,
  },
})
export default class ModelType extends Vue {
  pager: RequestPaging = new RequestPaging();
  searchObj: any = {
    zh_cn_name: "",
  };

  dataForm = {
    id: "",
    zh_cn_name: "",
    en_name: "",
    color: "",
    remark: "",
    sort: 1,
    status: 1,
    model_tag_category_id: 0,
  };

  formData = [
    {
      type: "select",
      label: "分类",
      key: "model_tag_category_id",
      rules: [{ required: true, message: "请输入名称", trigger: "change" }],
      list: [],
    },
    {
      type: "input",
      label: "名称",
      key: "zh_cn_name",
      rules: [{ required: true, message: "请输入名称", trigger: "blur" }],
    },
    {
      type: "input",
      label: "英文名称",
      key: "en_name",
      rules: [{ required: true, message: "请输入英文名称", trigger: "blur" }],
    },
    {
      type: "colorpicker",
      label: "颜色",
      key: "color",
    },
    {
      type: "input",
      label: "备注",
      key: "remark",
    },
    {
      type: "input",
      label: "排序",
      key: "sort",
    },
    {
      type: "radio",
      label: "状态",
      key: "status",
      list: [
        { label: "正常", value: 1 },
        { label: "停用", value: 0 },
      ],
    },
  ];

  mode = "add";
  formVisible = false;

  handleAdd() {
    this.dataForm = {
      id: "",
      zh_cn_name: "",
      en_name: "",
      color: "",
      remark: "",
      model_tag_category_id: 0,
      sort: 1,
      status: 1,
    };
    this.mode = "add";
    this.formVisible = true;
  }

  handleEdit(row: any) {
    this.dataForm = {
      id: row.id,
      zh_cn_name: row.zh_cn_name,
      en_name: row.en_name,
      color: row.color,
      remark: row.remark,
      model_tag_category_id: row.model_tag_category_id,
      sort: row.sort,
      status: row.status,
    };
    this.mode = "edit";
    this.formVisible = true;
  }

  handleSubmit(value: object) {
    if (this.mode == "add") {
      apiModelModelTagAdd(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    } else {
      apiModelModelTagEdit(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    }
  }

  handleDelete(id: number) {
    apiModelModelTagDelete({ id: id }).then((res: any) => {
      this.getList();
    });
  }

  getList(): void {
    this.pager.request({
      callback: apiModelModelTagLists,
      params: {
        ...this.searchObj,
      },
    });
  }

  created() {
    apiModelModelTagCategoryLists({ page_no: 1, page_size: 100 }).then(
      (res: any) => {
        let list = res.lists.map((item: any) => {
          return {
            label: item.zh_cn_name,
            value: item.id,
          };
        });
        this.formData[0].list = list;
      }
    );
    this.getList();
  }
}
